import { useQuery } from "@tanstack/react-query"
import { getAttendanceLeaderboard } from "api/employeeKpiApi"

export const useAttendanceLeaderboard = (month, year) => {
  return useQuery({
    queryKey: ["attendance-leaderboard", month, year],
    queryFn: () => getAttendanceLeaderboard({ month, year }),
    staleTime: 1000 * 60 * 5,
  })
}
